export default "__VITE_ASSET__8zDAU33Z__"